import BehaviorConfig from '@/models/app-config/behavior/behavior'
import CartSignUpDefaultAttention from '@spa/components/pages/cart/components/signup/default/DefaultAttention.vue'
import CartSignUpDefaultFormNote from '@spa/components/pages/cart/components/signup/default/DefaultFormNote.vue'
import Vue, { VueConstructor } from 'vue'

export interface SignUpFormParts {
  readonly note: VueConstructor
  readonly attention: VueConstructor
}
type SignUpFormPartsGenerator = (behavior: BehaviorConfig) => SignUpFormParts

type DefaultSignUpFormPartsGenerator = (option?: Partial<SignUpFormParts>) => SignUpFormPartsGenerator
export const defaultSignUpFormParts: DefaultSignUpFormPartsGenerator = (option = {}) => behavior => ({
  note: defaultNote(behavior.groupLabel),
  attention: defaultAttention(behavior.groupLabel),
  ...option,
})
const defaultNote = (hostName: string) => Vue.extend({
  components: { CartSignUpDefaultFormNote },
  template: `<cart-sign-up-default-form-note host-name="${hostName}" />`,
})
const defaultAttention = (hostName: string) => Vue.extend({
  components: { CartSignUpDefaultAttention },
  template: `<cart-sign-up-default-attention host-name="${hostName}" />`,
})

export const mycolorSignUpFormParts = defaultSignUpFormParts()

export const vilbSignUpFormParts = defaultSignUpFormParts({
  note: defaultNote('美ラボ'),
  attention: defaultAttention('美ラボ'),
})

export const fitowaSignupFormParts = defaultSignUpFormParts({
  note: defaultNote('FITOWA'),
  attention: defaultAttention('FITOWA'),
})

export const loadingFormParts: SignUpFormParts = {
  note: Vue.extend({ template: '<div></div>' }),
  attention: Vue.extend({ template: '<div></div>' }),
}
